import {DocumentDownload} from '@constellation/core/icons';
import {PDFDownloadLink} from '@react-pdf/renderer';
import moment from 'moment';
import {
  JOURNEY_EVENT,
  LINK_VALUE,
  TAGGING_FIELDS,
} from '../../../../../enums/tagging/index.js';
import {type cardPaymentProps} from '../../../../../types/cardPaymentServiceDetails.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import QuoteDocument from '../QuoteDocument/QuoteDocument.js';
import {DownloadButton} from '../Styles/Styles.js';

const Download = (props: cardPaymentProps) => {
  const currentDate = moment(new Date()).format('DD-MM-YYYY');
  const fileName = `${getPsrLabel(
    'cardPaymentServicesDetails.fileNamePrefix'
  )}${currentDate}${getPsrLabel(
    'cardPaymentServicesDetails.fileNameExtension'
  )}`;

  return (
    <PDFDownloadLink
      document={<QuoteDocument {...props} />}
      fileName={fileName}
    >
      {() => (
        <DownloadButton
          aria-hidden='true'
          aria-label={getPsrLabel('cardPaymentServicesDetails.downloadSrText')}
          eventAction={JOURNEY_EVENT.BUTTON_CLICK}
          fieldName={TAGGING_FIELDS.DOWNLOAD_QUOTE}
          icon={<DocumentDownload iconSize='lg' trim={true} />}
          iconPosition='left'
          journeyAction={JOURNEY_EVENT.SUPPORTING_MATERIAL}
          journeyActionNarrative={TAGGING_FIELDS.DOWNLOAD_QUOTE}
          journeyEvent={JOURNEY_EVENT.GLOSSARY_CLICK}
          linkValue={LINK_VALUE.downloadquote}
          qaAnswer={JOURNEY_EVENT.SUPPORTING_MATERIAL}
          qaQuestion='pdf'
          resourceFileName={fileName}
          taggingLabel={TAGGING_FIELDS.DOWNLOAD_QUOTE}
        >
          {getPsrLabel('cardPaymentServicesDetails.download')}
        </DownloadButton>
      )}
    </PDFDownloadLink>
  );
};

export default Download;
